import {create} from 'zustand'

export const useToggleIntercomWidget = create(set => ({
  showWidget: true,
  toggleWidget: data => set({showWidget: data}),
}))
